import { throttle } from '@theme/utilities';

const ZOOM_IN_CLASSNAME = 'animate--zoom-in';
const ZOOM_INITIALIZED_ATTR = 'data-zoom-initialized';
const SCALE_MULTIPLIER = 0.2 / 100;

const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    return 0;
  }

  if (elementPositionY + elementHeight < scrollY) {
    return 100;
  }

  const distance = scrollY + viewportHeight - elementPositionY;
  const percentage = distance / ((viewportHeight + elementHeight) / 100);

  return Math.round(percentage);
}

function initializeZoomAnimation(element) {
  if (element.hasAttribute(ZOOM_INITIALIZED_ATTR)) return;

  let elementIsVisible = false;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      elementIsVisible = entry.isIntersecting;
    });
  });

  observer.observe(element);

  const updateScale = () => {
    element.style.setProperty('--zoom-in-ratio', 1 + SCALE_MULTIPLIER * percentageSeen(element));
  };

  updateScale();

  const handleScroll = throttle(() => {
    if (!elementIsVisible) return;

    updateScale();
  }, 200);

  window.addEventListener('scroll', handleScroll, { passive: true });

  element.setAttribute(ZOOM_INITIALIZED_ATTR, 'true');
}

function initializeZoomAnimations(root = document) {
  if (prefersReducedMotion()) return;

  const elements = root instanceof Element ? root.querySelectorAll(`.${ZOOM_IN_CLASSNAME}`) : document.querySelectorAll(`.${ZOOM_IN_CLASSNAME}`);

  elements.forEach(initializeZoomAnimation);
}

document.addEventListener('DOMContentLoaded', () => initializeZoomAnimations());

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeZoomAnimations(event.target));
  document.addEventListener('shopify:section:reorder', () => initializeZoomAnimations(document));
}
